import { FaLinkedin } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './footer.css';

const CALENDLY_URL = 'https://calendly.com/cloudsibyl/demo';
const LINKEDIN_URL = 'https://www.linkedin.com/company/cloudsibyl/';

const FooterSection = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer-section">
      <div className="footer-columns">
        <div className="footer-col">
          <h3 className="footer-col-title">{t('footer_product')}</h3>
          <ul className="footer-links">
            <li><Link to="/">{t('nav_flowry')}</Link></li>
            <li><Link to="/finops">{t('nav_finops')}</Link></li>
            <li><a href="/finops#features">{t('footer_features')}</a></li>
            <li><a href="/finops#cloud-challenges">{t('footer_cloud_challenges')}</a></li>
          </ul>
        </div>
        <div className="footer-col">
          <h3 className="footer-col-title">{t('footer_company')}</h3>
          <ul className="footer-links">
            <li><a href="/finops#timeline">{t('footer_our_journey')}</a></li>
            <li><Link to="/#team">{t('footer_team')}</Link></li>
          </ul>
        </div>
        <div className="footer-col">
          <h3 className="footer-col-title">{t('footer_connect')}</h3>
          <ul className="footer-links">
            <li><a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer">{t('schedule')}</a></li>
            <li>
              <a
                title="CloudSibyl LinkedIn"
                href={LINKEDIN_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-linkedin"
              >
                <FaLinkedin size={22} /> LinkedIn
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p className="footer-copyright">{t('footer_copyright')}</p>
      </div>
    </footer>
  );
};

export default FooterSection;
